<template>
  <div class="listmain ">
    <h1 class="firTitle">License文档</h1>
    <h3 class="sedTitle">简述</h3>
    <p>开发者可通过开放平台SDK下载页面，提交lisense申请，后台审核通过后，自动生成lisense并提供下载。</p>
    <p>申请成功后会收到短信及消息通知，开发者可通过失效日期查看当前SDK失效时间，如需正式版可邮件发送至
        <a href="Mailto:http://orion@ainirobot.com">sunjianan@ainirobot.com</a>
        申请</p>
    <h3 class="sedTitle">接入流程</h3>
    <p>1.sdk下载页面提交License申请</p>
      <img src="../../../static/images/license2.png" style="width:740px"/>
    <p>2.提交申请，填写Android包名，license与android包名绑定，如更换android包名需License过期后重新申请，或邮件发送至<a href="Mailto:http://orion@ainirobot.com">sunjianan@ainirobot.com</a></p>
      <img src="../../../static/images/license3.png" style="width:740px"/>
      <p>3.申请通过后，您将收到短信及消息通知，同时可在SDK下载页面下载License文件</p>
      <p>4.将下载完成的license文件放置到Android工程的asset文件夹下即可</p>
      <p>5.License过期后需要重新申请</p>

  </div>
</template>

<script>
  export default {
    name: ""
  };

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }

  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle {
      margin-top: 50px;
      font-weight: bold;
      line-height: 26px;
    }
    .codeTitle {
      font-weight: bold;
      line-height: 26px;
    }
    pre {
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/tutor/License.vue